/**
 * ============================================================
 * TEMPLATE: Promoții - Piese de Schimb
 * ============================================================
 *
 * Pentru a adăuga/modifica promoții, editează array-ul de mai jos.
 * Fiecare produs trebuie să aibă următoarele câmpuri:
 *
 *   name        – Numele piesei de schimb
 *   partNumber  – Codul/numărul piesei (opțional)
 *   description – Descrierea în română și engleză
 *   image       – URL-ul imaginii produsului
 *   oldPrice    – Prețul vechi (opțional, pentru afișarea reducerii)
 *   newPrice    – Prețul promoțional
 *   currency    – Moneda (ex: "EUR", "RON")
 *   inStock     – Dacă este în stoc (true/false)
 *   validUntil  – Data până la care este valabilă promoția (opțional)
 *
 * Exemplu:
 *   {
 *     name: "Filtru hidraulic XYZ",
 *     partNumber: "WIT-FH-001",
 *     description: {
 *       ro: "Filtru hidraulic compatibil cu seria SmartPower.",
 *       en: "Hydraulic filter compatible with SmartPower series.",
 *     },
 *     image: "https://example.com/image.jpg",
 *     oldPrice: 250,
 *     newPrice: 199,
 *     currency: "EUR",
 *     inStock: true,
 *     validUntil: "2026-06-30",
 *   }
 * ============================================================
 */

export interface SparePartPromotion {
  name: string;
  partNumber?: string;
  description: { ro: string; en: string };
  image: string;
  oldPrice?: number;
  newPrice: number;
  currency: string;
  inStock: boolean;
  validUntil?: string;
  condition: "new" | "used";
}

export const sparePartPromotions: SparePartPromotion[] = [
  // ── Adaugă produsele promoționale mai jos ──────────────────
  {
    name: "Filtru hidraulic SmartPower",
    partNumber: "WIT-FH-001",
    description: {
      ro: "Filtru hidraulic original compatibil cu seria SmartPower B8X. Performanță garantată.",
      en: "Original hydraulic filter compatible with SmartPower B8X series. Guaranteed performance.",
    },
    image: "https://wittmann-group.ro/img.promo/filter.webp",
    oldPrice: 250,
    newPrice: 199,
    currency: "EUR",
    inStock: false,
    validUntil: "2026-06-30",
    condition: "new",
  },
  {
    name: "Kit garnituri EcoPower",
    partNumber: "WIT-GK-045",
    description: {
      ro: "Set complet de garnituri pentru unitățile de injecție EcoPower 110-300t.",
      en: "Complete seal kit for EcoPower 110-300t injection units.",
    },
    image: "https://wittmann-group.ro/img.promo/seal.webp",
    oldPrice: 180,
    newPrice: 139,
    currency: "EUR",
    inStock: false,
    validUntil: "2026-06-30",
    condition: "new",
  },
  {
    name: "Motor robot Seria R7",
    partNumber: "WIT-MR7-045",
    description: {
      ro: "Motor complet cu reductor si frana pentru roboti seria R7 pentru Axa Z",
      en: "Motor complet cu reductor si frana pentru roboti seria R7 pentru Axa Z",
    },
    image: "https://wittmann-group.ro/img.promo/motor.webp",
    oldPrice: 400,
    newPrice: 139,
    currency: "EUR",
    inStock: false,
    validUntil: "2026-06-30",
    condition: "used",
  },
  // ── Adaugă mai multe produse aici ──────────────────────────
];
